import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { Collaborator, Share } from '../../../core/store/models/content-share.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class ContentShareApiService {
  constructor(private http: HttpService) {}

  public getUserCollaborators(contentUId: string): Observable<Collaborator[]> {
    const url = `${apiBaseUrl}/v1/meta/contentShare/${contentUId}/userProfiles`;

    return this.http.get<Collaborator[]>(url);
  }

  public getSecurityGroupCollaborators(contentUId: string): Observable<Collaborator[]> {
    const url = `${apiBaseUrl}/v1/meta/contentShare/${contentUId}/securityGroups`;

    return this.http.get<Collaborator[]>(url);
  }

  public getCollaborators(contentUIds: string[]): Observable<Share[]> {
    const url = `${apiBaseUrl}/v1/meta/contentShare/collaborators`;

    return this.http.post<Share[]>(url, contentUIds);
  }
}
